.uploadInput {
  /* Difficult to style hence disabled */
  opacity: 0;
  height: 0;
  width: 0;
}

.inputWrapper {
  display: flex;
  margin: 0.5rem 0;
}

.label {
  display: flex;
  gap: 1rem;
  justify-content: center;
  align-items: center;
  padding: 0.4rem 0.8rem;
  border: 0.8px solid #868989;
  border-radius: 0.3rem;
  cursor: pointer;
}

.label:hover {
  background-color: #fafafa;
}

.fileDetails {
  display: flex;
  flex-direction: column;
  padding-left: 1rem;
}
